import type { FeatureItem, HotRow, NewsItem } from "./types";

export const news: NewsItem[] = [
  {
    id: "n1",
    channel: "schedule",
    title: "网曝某顶流月底空降沪上地标商圈，主办方疑似已开启清场与彩排",
    excerpt:
      "多位现场人员透露，某顶流艺人或将月底空降上海核心商圈举办线下快闪，商场部分楼层已开始预留动线与安保彩排。",
    date: "09-06",
    source: "现场目击 · 主办方外围",
    heat: 9820,
    tags: ["行程预警", "空降预热"],
    feel: "多方互证",
    body: [
      "据多位在沪的现场工作人员交叉反馈，上海某核心商圈地标项目的临街部分楼层近期已进入封闭式布置阶段，夜间多次出现整装彩排与清场。综合动线预留与档期来看，这更像是一场为顶流级别艺人准备的线下快闪或品牌活动。",
      "有知情人进一步透露，活动主办方为这次落地开了“绿灯”，连普通保安的排班表都明显加厚，且明确要求外围人员签署保密协议。这类‘清场 + 彩排 + 保密’的组合，在圈内通常只出现在级别较高的空降级活动上。",
      "需要提醒的是，目前一切仍处于主办方内部推进阶段，具体时间、地点与参与艺人尚未官宣。我们会持续盯紧现场围挡与地标大屏，一旦出现倒计时物料会第一时间更新。",
    ],
  },
  {
    id: "n2",
    channel: "resource",
    title: "某85花新项目疑陷换角风波，资方压价续约引发粉丝反弹",
    excerpt:
      "网传某85花的新项目在临开机阶段陷入换角风波，资方以“市场行情”为由压价，双方续约谈判一度陷入僵持。",
    date: "09-06",
    source: "制片组外围 · 粉丝群体",
    heat: 9160,
    tags: ["资源瓜", "换角"],
    feel: "纯属推测",
    body: [
      "一条关于某85花新项目临开机前突生变数的消息在粉丝圈迅速扩散。有自称制片组外围人员的人士称，资方近期以‘市场行情回调’为由重新议价，与团队此前谈好的片酬与番位存在落差，导致开机时间被反复敲定。",
      "从粉丝行动来看，相关热搜词条下已出现大量‘拒绝压价’的应援与抗议，多个官方后援会连夜发声要说法，侧面印证双方沟通并不顺畅。类似的临开机议价在行业里并不少见，最终往往以某一方让步收尾。",
      "目前片方尚未就演员阵容与开机档期给出任何正式说明，建议以最终官宣为准，我们也会持续关注资方后续放出的物料节奏。",
    ],
  },
  {
    id: "n3",
    channel: "drama",
    title: "曝某待爆男演员接到刑侦悬疑大饼，或与一线导演二搭冲奖",
    excerpt:
      "业内传某待爆男演员收到一部头部刑侦悬疑剧的本子邀约，若谈成将是他与某一线导演的二次合作。",
    date: "09-05",
    source: "业内平台 · 编剧侧",
    heat: 8730,
    tags: ["新戏饼", "刑侦悬疑"],
    feel: "网传中",
    body: [
      "在多个剧组选角相关的业内小组里，开始流传一份名单：某位接连交出亮眼成绩的待爆男演员，被列入一部头部刑侦悬疑剧的男主候选。若消息属实，这将是他在积累口碑后首次硬碰硬地冲击质感大男主。",
      "更让瓜民在意的是导演人选——爆料称双方存在‘二搭’可能，因为该导演上一部作品由对方担任重要配角且合作默契。二搭冲奖的叙事一旦成立，这条饼在资源盘里的分量会明显上升。",
      "目前剧本仍处于打磨阶段，男主角并未正式签约。这类大饼通常要等剧本定稿与平台排期敲定后才会官宣，现阶段请当作方向性情报看待。",
    ],
  },
  {
    id: "n4",
    channel: "variety",
    title: "某实力唱将确认收到暑期音综邀约，首轮竞演曲目已开始备选",
    excerpt:
      "据节目组内部人士消息，某实力唱将已收到暑期档音综的正式邀约，团队已进入首轮竞演曲目备选阶段。",
    date: "09-05",
    source: "节目组外围 · 音乐团队",
    heat: 8470,
    tags: ["综艺邀约", "音综"],
    feel: "多方互证",
    body: [
      "距离暑期档录制还有一段时间，但某音综的拟邀名单已经在外围露头。最受关注的是那位以唱功与现场爆发力著称的实力唱将——多方消息都指向他已收到节目组正式邀约，而非此前网传的‘仅接触’。",
      "据其音乐团队内部人士透露，团队近期多次集中开选曲会，首轮竞演备选曲库超过二十首，风格横跨抒情与摇滚。‘选曲这么早启动，通常意味着档期已基本敲定’的说法在业内颇有市场。",
      "不过录制名单随时可能因档期冲突调整，最终以节目组与艺人方的官宣阵容为准。我们会继续跟进名单外流与官宣海报的节奏。",
    ],
  },
  {
    id: "n5",
    channel: "brand",
    title: "某新晋小花被曝接触高奢珠宝线，代言title或在月底空降官宣",
    excerpt:
      "市场端消息称某新晋小花正与一家高奢珠宝品牌接洽，若谈成有望拿下品牌线级别的代言title。",
    date: "09-04",
    source: "时尚圈层 · 品牌代理",
    heat: 8120,
    tags: ["商务代言", "高奢珠宝"],
    feel: "纯属推测",
    body: [
      "时尚与品牌圈近期传出动向：某人气正盛的新晋小花，正在与一家欧洲高奢珠宝品牌洽谈合作，谈判重心在于title是全线代言人还是更高一级的品牌大使。多位代理圈人士称接触‘已经进入比较实质的阶段’。",
      "这位小花近半年的造型与露出明显与高奢调性靠拢，商务团队也在有意筛选‘气质相符’的品牌，避免短平快的割韭菜代言拉低口碑。品牌方同样在评估其口碑稳定度与后续项目背书。",
      "高奢谈判周期通常较长且保密等级高，月底官宣的说法目前仍是传闻。我们建议瓜民先放平心态，等品牌官方与艺人工作室的联合官宣。",
    ],
  },
  {
    id: "n6",
    channel: "schedule",
    title: "网传某老牌视帝已秘密抵横店，疑为新剧提前进组围读",
    excerpt:
      "有影城工作人员称在某酒店目击某老牌视帝低调入住，疑似为一部年代正剧提前进组围读剧本。",
    date: "09-04",
    source: "横店现场 · 影城酒店",
    heat: 7790,
    tags: ["行程预警", "进组"],
    feel: "网传中",
    body: [
      "横店某影城酒店的工作人员在社交平台晒出‘低调大佬入住’的模糊消息，评论区不少资深瓜民据此推断是老牌视帝提前进组。理由是该剧筹备已久的年代正剧预计近期围读，而视帝一向有提前进组研读剧本的习惯。",
      "从公开行程看，该视帝近期确实空窗、没有官宣的公开活动，与‘秘密南下’的时间线对得上。若属实，这将是他在沉潜两年后的又一次正剧回归，投资与平台侧应该都已给足诚意。",
      "不过在剧组正式放出定妆或开机消息前，酒店目击仍属于间接线索。我们会持续关注剧组的围读与开机节奏。",
    ],
  },
  {
    id: "n7",
    channel: "pop",
    title: "某男团主唱今晚空降个人直播间，官方已释出倒计时预告",
    excerpt:
      "某男团主唱所属公司于傍晚放出预告：成员将于今晚空降个人直播间，预计带来新歌片段与粉丝互动。",
    date: "09-04",
    source: "官方社媒预告",
    heat: 9650,
    tags: ["空降活动", "直播"],
    feel: "实锤度高",
    body: [
      "今晚的瓜基本算‘半官宣’了——某男团主唱所属公司傍晚在官方社媒发布倒计时海报，确认成员将于今晚空降个人直播间。这也是该成员时隔数月后的首次个人向直播，消息一出立刻冲上讨论热榜。",
      "据站姐与内部人士透露，直播间预计会有两段新歌片段的首度释出，并安排与粉丝的实时点歌互动环节。为了这次空降，团队连麦设备与直播机位都做了双保险准备，可见重视程度不低。",
      "具体开播时间与内容以官方为准，建议瓜民定好闹钟。想看完整分析、逐条整理今晚直播重点的，可以盯紧我们后续的速报。",
    ],
  },
  {
    id: "n8",
    channel: "variety",
    title: "网曝某综艺第二季拟邀两组“破镜重圆”组合，招商PPT外流",
    excerpt:
      "一份疑似第二季招商PPT在网上流传，其中‘情怀重组’单元拟邀两组曾解散或久未同框的组合回归。",
    date: "09-03",
    source: "招商渠道 · 营销圈",
    heat: 7380,
    tags: ["综艺邀约", "情怀"],
    feel: "纯属推测",
    body: [
      "一份标注着某老牌综艺第二季的招商方案在营销圈流传，方案里专门设置了‘破镜重圆’情怀单元，拟邀两组曾经解散或多年未曾同框的组合。策划页那句‘欠粉丝一个合体’的文案被大量截图传播。",
      "业内人士分析，这类情怀向设定在招商阶段极易打动品牌，因为它自带讨论度与粉丝购买力。但招商PPT上的拟邀名单历来‘含水量’不低，往往是用来敲品牌预算的‘勾子’。",
      "也就是说，这份名单能看到‘方向’，但不代表最终成团。真正的录制阵容，要等节目组官宣与艺人档期双双落地才有参考价值。",
    ],
  },
  {
    id: "n9",
    channel: "drama",
    title: "业内传某古装大剧重启在即，男女主拟用“高国民度+新人”配置",
    excerpt:
      "业内传一部搁置数年的古装大剧即将重启，选角方向倾向于“高国民度中生代 + 潜力新人”的安全牌组合。",
    date: "09-03",
    source: "业内平台 · 编剧侧",
    heat: 7050,
    tags: ["新戏饼", "古装"],
    feel: "网传中",
    body: [
      "一部曾因档期与资金问题搁置数年的古装大剧，传出‘重启在即’的消息。据编剧侧消息，重启后的项目明显下调了体量预期，走‘稳扎稳打’路线，选角也倾向‘高国民度中生代挑大梁 + 潜力新人搭配’的组合拳。",
      "这种配置在近年爆款里屡试不爽——既有中生代演技兜底保证质感，又能借新人话题拉满宣发热度。爆料提到男主候选名单上出现了多位“戏好但很久没大爆”的实力派，女主则瞄准两三位被看好的95后小花。",
      "目前仍停留在意向阶段，平台过会与主创敲定都还没最终落定。这条饼能不能真正‘开火’，我们持续跟进。",
    ],
  },
  {
    id: "n10",
    channel: "brand",
    title: "某运动品牌被曝锁定新晋人气选手，代言意向在最后审批阶段",
    excerpt:
      "商业侧消息称某头部运动品牌已将一位人气正盛的新晋选手列为代言候选人，目前进入内部最后审批阶段。",
    date: "09-02",
    source: "品牌代理 · 体育营销",
    heat: 6680,
    tags: ["商务代言", "运动"],
    feel: "纯属推测",
    body: [
      "体育营销圈传出消息：某头部运动品牌在权衡多位候选后，将一位人气正盛的新晋选手列为下一阶段代言候选人，合作条款已在法务层面做最后审批。若成行，品牌将围绕他打造一整套开学季与新品线的传播战役。",
      "品牌选择他，看重的是其‘成绩 + 流量 + 少年感’三合一的稀缺属性——既能讲硬核竞技故事，又能撬动年轻消费者。据营销侧人士估算，若官宣，相关物料与线下投放的预算规模不小。",
      "不过品牌审批环节变数较多，出现‘临门一脚换人’也时有发生。在正式官宣前，建议把这条当作高可信的方向性情报看待。",
    ],
  },
  {
    id: "n11",
    channel: "pop",
    title: "网曝某天后级歌手下月连开三场体育场，票务系统已开始压力测试",
    excerpt:
      "票务与技术侧消息称，某天后级歌手下月或连开三场体育场级别演唱会，相关票务系统已进入压力测试阶段。",
    date: "09-02",
    source: "票务侧 · 技术圈层",
    heat: 8990,
    tags: ["空降活动", "演唱会"],
    feel: "网传中",
    body: [
      "票务与技术圈层近日传出声音：某天后级歌手下月很可能连开三场体育场级别的大型演唱会，且承接方已开始对购票系统做高并发压力测试，为抢票高峰做准备。",
      "三场连开的规格在现阶段的演出市场属于‘顶配’，意味着制作成本与档期投入都拉满。知情者透露，主办方在选址与审批上已推进到比较靠后的阶段，周边酒店与交通预案也已同步启动。",
      "目前主办方与艺人团队均未发布官宣，场次、城市与开票时间仍待确认。想抢票的瓜民可以先关注官方售票预告，我们会第一时间同步开票节奏。",
    ],
  },
];

export const tickerHeadlines: string[] = [
  "某顶流月底空降沪上商圈，清场与彩排已启动",
  "某85花新项目疑陷换角风波，资方压价引发反弹",
  "某待爆男演员收到刑侦大饼，或与一线导演二搭",
  "某男团主唱今晚空降直播，新歌片段首度释出",
  "某天后下月连开三场体育场，票务已开始压测",
  "某古装大剧重启在即，选角拟用安全牌组合",
];

export const hotRows: HotRow[] = [
  { id: "n1", num: "01", trend: "up", delta: "+1280" },
  { id: "n7", num: "02", trend: "new", delta: "新上榜" },
  { id: "n11", num: "03", trend: "up", delta: "+920" },
  { id: "n2", num: "04", trend: "down", delta: "-430" },
  { id: "n3", num: "05", trend: "flat", delta: "持平" },
  { id: "n4", num: "06", trend: "up", delta: "+310" },
  { id: "n5", num: "07", trend: "flat", delta: "持平" },
  { id: "n6", num: "08", trend: "up", delta: "+210" },
  { id: "n8", num: "09", trend: "down", delta: "-160" },
  { id: "n9", num: "10", trend: "flat", delta: "持平" },
];

export const features: FeatureItem[] = [
  {
    id: "f1",
    kind: "feature",
    title: "资源瓜是怎么流传的？一条“饼”如何从剧组一路溜到热搜",
    dek: "从导演饭局到站姐群再到营销号，一条新戏饼要经过几层把关才会变成你刷到的那条热搜？我们拆解资源瓜的完整传播链。",
    date: "09-05",
    readTime: "约 6 分钟",
    tags: ["深度", "资源瓜", "行业观察"],
    image:
      "https://readdy.ai/api/search-image?query=overhead%20flat%20lay%20editorial%20of%20a%20film%20clapperboard%20slate%20with%20golden%20coins%20and%20scattered%20cream%20casting%20cards%20on%20a%20warm%20beige%20desk%20red%20and%20amber%20accent%20lighting%20rich%20industry%20metaphor%20for%20casting%20and%20deals%20cinematic%20soft%20shadow%20high%20detail%20magazine%20infographic%20aesthetic%20no%20text%20no%20faces&width=1200&height=720&seq=radar-doc-1&orientation=landscape",
    body: [
      "几乎每个刷瓜的网友都好奇：为什么“饼”还只是传闻，我就已经能刷到谁要接哪部戏了？答案往往不在热搜上，而在一条层层往下游传递的链条里。",
      "第一步通常是“组局”：导演或制片人组饭局、递本子，这时同场的中介、编剧助理、甚至同组演员身边的工作人员，就已经拿到了第一手信息。这也是为什么资源瓜最密集的时期，往往发生在开机前的三个月到半年。",
      "第二步是“过会与招商”：项目进入平台过会、商务招商阶段，制片组的PPT会流向招商渠道。招商PPT上的拟邀名单，就是绝大多数“饼王”和“阵容瓜”的源头——它本身带有较强的招商属性，名字未必都能成真，但方向往往是真实的。",
      "第三步是“外溢”：当品牌、造型、场地等外围团队开始介入，动线排期与保密协议会让“知道的人”成倍增长。总会有工作人员在社交平台说漏嘴、被站姐拍到、或在打车软件上被拼到同路人。到这里，一条瓜已经很难收住了。",
      "所以你能看到的资源瓜，往往是“多源交叉”后的结果。我们整理的逻辑也一样：同一方向有多条独立信源互相印证、且时间线与公开物料吻合，我们就标注为“多方互证”；只有单方面说法、无法核实的，就老实标“纯属推测”。",
      "理解这条传播链还有个好处：你更能分辨哪些是“为招商放风”的饼，哪些是“真在推进”的事。前者看热度热闹就好，后者才值得你提前锁定档期与物料。",
    ],
  },
  {
    id: "f2",
    kind: "feature",
    title: "未官宣行程是怎么泄露的？空降情报背后的“供应链”拆解",
    dek: "空降活动还没官宣，为什么总有站姐提前蹲守？我们把未官宣行程的泄露环节一条条捋给你看。",
    date: "09-03",
    readTime: "约 5 分钟",
    tags: ["深度", "行程预警", "空降"],
    image:
      "https://readdy.ai/api/search-image?query=glowing%20radar%20scan%20screen%20map%20over%20a%20dark%20red%20and%20amber%20city%20skyline%20at%20night%20sweeping%20signal%20waves%20and%20location%20markers%20deep%20charcoal%20atmosphere%20spy%20intelligence%20aesthetic%20for%20celebrity%20schedule%20tracking%20cinematic%20high%20contrast%20no%20text%20no%20people&width=1200&height=720&seq=radar-doc-2&orientation=landscape",
    body: [
      "每次某位艺人的“空降”还没官宣，现场就已有人蹲守、甚至精准掐点放出位置——这背后不是玄学，而是一条由多个环节构成的“行程供应链”。",
      "第一个环节是航班与酒店系统。艺人订票、订房往往通过经纪团队与第三方票务完成，这些第三方内部一旦有人掌握信息，目的地城市就会提前“漏风”。这也是“行程瓜”最早也最常见的一个来源。",
      "第二个环节是活动现场的动线筹备。无论是商场快闪还是品牌发布会，落地前都要做清场、彩排、安保排班与物料进场。任何一个环节的第三方工作人员，都可能把“有大咖要来”的信息带出片场。",
      "第三个环节是公开物料的“排期推理”。很多行程其实就藏在官方社媒的倒计时、上线时段与联动节奏里——认真比对的人能反推出空降时间。我们栏目的“多方互证”等级，往往就来自这几个环节的消息能互相咬合。",
      "需要说明的是，行程瓜的准确度通常高于资源瓜：因为动线一旦敲定，临时反悔的成本很高。即便如此，只要没有官方确认，我们就坚持标注“尚未官宣”，避免把可能性说成必然。",
      "看懂这套供应链，你也就明白了为什么“空降情报”总比官宣早半步——那不是巧合，是信息在链条上真实流动的速度。",
    ],
  },
];